import { useContext } from "react"
import { useNavigate } from "react-router-dom"
import VicinityContext from "../context/vicinityContext"
import { handleLocationUpdate } from "../utilities/locations"

/**
 * Custom hook that provides a location update handler with all necessary context
 * @returns {Function} Location update handler function
 */
export const useLocationUpdate = () => {
    const navigate = useNavigate()
    const vicinityData = useContext(VicinityContext)
    const {
        place,
        setLocation,
        setPlace,
        setCountryCode,
        setToastMessage,
        setToastOptions,
        setShowToast,
        toastOptions,
    } = vicinityData

    return () =>
        handleLocationUpdate({
            currentPlace: place,
            setLocation,
            setPlace,
            setCountryCode,
            setToastMessage,
            setToastOptions,
            setShowToast,
            toastOptions,
            navigate,
        })
}
